// Daten, die vom Server an den Browser gegeben werden

export interface GlobalerFilterData {
	readonly Eigenschaften: Eigenschaft[];
	readonly Untergruppen: Untergruppe[];
	readonly Normblaetter: Normblatt[];
}

export interface Eigenschaft {
	readonly Name: string;
	readonly Bereichsauswahl: boolean;
	readonly BereichsauswahlOption: BereichsauswahlOption;
}

export enum BereichsauswahlOption {
	AuswahlUeberschreiten = 1,
	AuswahlNichtUeberschreiten = 2,
}

export interface Untergruppe {
	readonly Bezeichnung: string;
	readonly Eigenschaften: Eigenschaft[];
}

export interface Normblatt {
	readonly Guid: string;
	readonly Eigenschaften: NormblattEigenschaft[];
}

export type NormblattEigenschaft = NormblattEigenschaftBereich | NormblattEigenschaftWerte;

export interface NormblattEigenschaftBereich {
	readonly Name: string;
	readonly Werteliste: any;
}

export interface NormblattEigenschaftWerte {
	readonly Name: string;
	readonly Werte: Wert[];
}

export type Wert = string | number | null;
